var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplaneSquarePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM18.51 13.19C18.51 13.79 18.05 14.09 17.5 13.85L14.15 12.41C13.76 12.25 13.45 12.45 13.45 12.87V14.72C13.45 14.88 13.54 15.11 13.66 15.23L15.3 16.88C15.47 17.05 15.55 17.39 15.47 17.62L15.15 18.58C15.01 19 14.53 19.2 14.14 19L12.47 17.58C12.21 17.37 11.79 17.37 11.54 17.58L9.86 19C9.46 19.2 8.99 19 8.85 18.57L8.53 17.61C8.45 17.38 8.53 17.04 8.7 16.87L10.37 15.23C10.48 15.12 10.58 14.89 10.58 14.72V12.87C10.58 12.45 10.26 12.24 9.88 12.41L6.53 13.85C5.97 14.09 5.52 13.79 5.52 13.19V12.26C5.52 11.78 5.89 11.22 6.33 11.03L10.27 9.33C10.43 9.26 10.57 9.05 10.57 8.87V6.8C10.57 6.12 11.06 5.31 11.67 5.01C11.89 4.9 12.14 4.9 12.36 5.01C12.96 5.32 13.46 6.12 13.46 6.8V8.87C13.46 9.05 13.59 9.26 13.76 9.33L17.7 11.03C18.15 11.22 18.51 11.78 18.51 12.26V13.19Z",
    fill: "#8B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneSquarePurple);
export default __webpack_public_path__ + "97120/static/media/airplane-square-purple.1556539a339f814ab1c39757a3f961c3.svg";
export { ForwardRef as ReactComponent };